import React, { useState } from 'react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  IconButton,
  Typography,
  Grid,
} from '@mui/material';
import { format } from 'date-fns';
import ConfirmDialog from './ConfirmDialog';
import { useTranslation } from 'react-i18next';
import { getIcon } from '../../../utils/IconHandler';
import { schedule } from '../../../utils/Enums';
import { addStaffException } from '../../../services/StaffService';
import dayjs from 'dayjs';

const DeleteEventModal = ({ locationId, event, open, onClose, onDelete }) => {
  
  const { t } = useTranslation();
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  
  if (!event) return null;

  const handleDelete = () => {
    setConfirmOpen(true);
  };

  const confirmDelete = async () => {
    setLoading(true);
  
    // Parsear las fechas
    const startDate = new Date(event.start);
    const endDate = new Date(event.end);
  
    // Usar date-fns para formatear la fecha y la hora
    const date = format(startDate, 'yyyy-MM-dd') + 'T00:00:00'; // Fecha en formato ISO con hora 00:00:00
    const startHour = format(startDate, 'HH:mm:ss'); // Hora de inicio
    const endHour = format(endDate, 'HH:mm:ss'); // Hora de fin
  
    const request = {
      staff_email: event.staffEmail,
      location_id: parseInt(locationId),
      date: date,
      start_hour: startHour,
      end_hour: endHour,
      type: parseInt(schedule.OOO),
    };
    
    try {
      await addStaffException(request);
    } catch (error) {
      console.error('Error eliminando evento:', error);
    } finally {
      setConfirmOpen(false);
      setLoading(false);
      onDelete();
      onClose();
    }
  };

  return (
    <>
      <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
        <DialogTitle>
          <Typography variant="h6">{event.title}</Typography>
          <div style={{ position: 'absolute', right: 16, top: 16 }}>
            <IconButton style={{ marginLeft: "4px" }} onClick={handleDelete}>
                {getIcon('trash')}
            </IconButton>
          </div>
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="subtitle1" color="textSecondary">
                {t('Inicio')}
              </Typography>
              <Typography>{dayjs(event.start).format('DD/MM/YYYY - HH:mm')}</Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="subtitle1" color="textSecondary">
                {t('Fin')}
              </Typography>
              <Typography>{dayjs(event.end).format('DD/MM/YYYY - HH:mm')}</Typography>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>{t('Cerrar')}</Button>
        </DialogActions>
      </Dialog>

      <ConfirmDialog
        isLoading={loading}
        open={confirmOpen}
        onClose={() => setConfirmOpen(false)}
        onConfirm={confirmDelete}
      />
    </>
  );
};

export default DeleteEventModal;
